import { createAction } from '../Action';

export const setCurrentlyPlaying = createAction('AUDIO_SET_CURRENT')<{ sid: string }>();

export type SetCurrentlyPlaying = ReturnType<typeof setCurrentlyPlaying>;

export type VoiceActions = SetCurrentlyPlaying;
